<div>
    <mat-card class="{{ visibilityClassName }}">
        <mat-card-content>
            <button class="{{ actionButton.isUnavailable ? 'action-invisible' : '' }}" mat-button *ngFor="let actionButton of customActionButtons" (click)="action(actionButton.actionName)" [disabled]="actionButton.disabled == 'disabled'">
                <mat-icon class="material-symbols-outlined">
                    {{ actionButton.iconName }}
                </mat-icon>
                {{ actionButton.caption }}
            </button>
            <button *ngIf="applicationActionButtons.length > 0" mat-button (click)="appService.toggleappFeedPane()">
                <mat-icon class="material-symbols-outlined">
                    brand_awareness
                </mat-icon>
                APP FEED
            </button>
        </mat-card-content>
    </mat-card>
</div>
